import bootstrap from "bootstrap";

function initBootstrapTooltips()
{
    let tooltipTriggerList: Element[] = [...document.querySelectorAll('[data-bs-toggle="tooltip"]')];

    let tooltipList = tooltipTriggerList.map(element => new bootstrap.Tooltip(element));

    console.log("Bootstrap tooltips initialized");
}

console.log("Before initBootstrapTooltips()");

initBootstrapTooltips();

console.log("After initBootstrapTooltips()");
